<script setup lang="ts">
import { CarouselPrevious, CarouselIndicator, CarouselNext, useCarousel } from '.';
import { cn } from '../../../lib/utils';

interface Props {
  initialCount?: number,
}

defineProps<Props>();

const { orientation } = useCarousel()

</script>

<template>
  <div :class="cn('c-carousel-step-counter flex flex-row gap-24 items-center',
    orientation === 'horizontal'
      ? 'flex-row'
      : 'flex-col',
  )">
    <CarouselPrevious/>
    <CarouselIndicator :initial-count="initialCount" />
    <CarouselNext/>
  </div>
</template>

<style scoped>
.c-carousel-step-counter {
  color: var(--c-carousel-indicator-color);
}
</style>